// import user from './user.vue'
// import product from './product.vue'
// import order from './order.vue'
// import tag from './tag.vue'
// // import dashboard from './dashboard.vue'
const productDetail = resolve =>
  require(['@/pages/authorized/product-detail.vue'], resolve)
const dashboard = resolve =>
  require(['@/pages/authorized/dashboard.vue'], resolve)
const order = resolve => require(['@/pages/authorized/order.vue'], resolve)
const orderDetail = resolve =>
  require(['@/pages/authorized/order-detail.vue'], resolve)
const product = resolve => require(['@/pages/authorized/product.vue'], resolve)
const user = resolve => require(['@/pages/authorized/user.vue'], resolve)
const userDetail = resolve => require(['@/pages/authorized/user-detail.vue'], resolve)
const plan = resolve => require(['@/pages/authorized/plan.vue'], resolve)
const changePwd = resolve => require(['@/pages/authorized/change-pwd.vue'], resolve)
const store = resolve => require(['@/pages/authorized/store.vue'], resolve)
const subsidiary = resolve => require(['@/pages/authorized/subsidiary.vue'], resolve)
const channel = resolve => require(['@/pages/authorized/channel.vue'], resolve)
const subsidiaryDetail = resolve => require(['@/pages/authorized/subsidiary-detail.vue'], resolve)
const channelDetail = resolve => require(['@/pages/authorized/channel-detail.vue'], resolve)
const admin = resolve => require(['@/pages/authorized/admin.vue'], resolve)
const adminDetail = resolve => require(['@/pages/authorized/admin-detail.vue'], resolve)
const storeDetail = resolve => require(['@/pages/authorized/store-detail.vue'], resolve)
const logs = resolve => require(['@/pages/authorized/logs.vue'], resolve)
const vechainorder = resolve => require(['@/pages/authorized/vechainorder.vue'], resolve)
const vechainorderCreate = resolve => require(['@/pages/authorized/vechainorder-create.vue'], resolve)


export default [
  {
    name: 'dashboard',
    path: 'dashboard',
    meta: {
      name: 'dashboard'
    },
    component: dashboard
  },
  {
    name: 'user',
    path: 'user',
    meta: {
      name: 'user'
    },
    component: user
  },
  {
    name: 'userDetail',
    path: '/user/:action/:id?',
    meta: {
      name: 'user'
    },
    component: userDetail
  },
  {
    name: 'product',
    path: 'product',
    meta: {
      name: 'product'
    },
    component: product
  },
  {
    name: 'order',
    path: 'order',
    meta: {
      name: 'order'
    },
    component: order
  },
  {
    name: 'orderDetail',
    path: 'order/detail/:id',
    meta: {
      name: 'order'
    },
    component: orderDetail
  },
  {
    name: 'tag',
    path: '/tag',
    meta: {
      name: 'tag'
    },
    component: plan
  },
  {
    name: 'productDetail',
    path: '/product/:action/:id',
    meta: {
      name: 'product'
    },
    component: productDetail
  },
  {
    name: 'changePwd',
    path: '/changepassword',
    component: changePwd
  },
  {
    name: 'store',
    path: '/store',
    meta: {
      name: 'store'
    },
    component: store
  },

  {
    name: 'storeDetail',
    path: '/store/:action/:id?',
    meta: {
      name: 'store'
    },
    component: storeDetail
  },
  {
    name: 'subsidiary',
    path: '/subsidiary',
    meta: {
      name: 'subsidiary'
    },
    component: subsidiary
  },
  {
    name: 'subsidiaryDetail',
    path: '/subsidiary/:action/:id',
    meta: {
      name: 'subsidiary'
    },
    component: subsidiaryDetail
  },
  {
    name: 'channel',
    path: '/channel',
    meta: {
      name: 'channel'
    },
    component: channel
  },
  {
    name: 'channelDetail',
    path: '/channel/:action/:id',
    meta: {
      name: 'channel'
    },
    component: channelDetail
  },
  {
    name: 'admin',
    path: '/admin',
    meta: {
      name: 'admin'
    },
    component: admin
  },
  {
    name: 'adminDetail',
    path: '/admin/:action/:id?',
    meta: {
      name: 'admin'
    },
    component: adminDetail
  },
  {
    name: 'logs',
    path: '/logs',
    meta: {
      name: 'logs'
    },
    component: logs
  },
  {
    name: 'vechainorder',
    path: '/vechainorder',
    meta: {
      name: 'vechainorder'
    },
    component: vechainorder
  },
  {
    name: 'vechainorderCreate',
    path: '/vechainorder/:action',
    meta: {
      name: 'vechainorder'
    },
    component: vechainorderCreate
  }
  // {
  //   name: 'plan',
  //   path: '/plans',
  //   meta: {
  //     name: 'plan'
  //   },
  //   component: plan
  // }
]



// WEBPACK FOOTER //
// ./src/pages/authorized/router.js